import { buildHorizontalExpressionTrace } from './utils';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { PlotContainer } from '@lifeomic/phc-web-toolkit/src/components/Plot/PlotContainer';
import * as React from 'react';
import Plot from 'react-plotly.js';
import useWindowSize from '@lifeomic/chroma-react/hooks/events/useWindowSize';

// We set a static height for the plot so that rendering inside of an
// ExpansionPanel component doesn't cause issues.
const plotHeight = 800;

const messages = defineMessages({
  geneExpressionLevel: {
    id: 'omicsExplorer.variantDetails.dialog.visualizations.expressionVisuals.boxPlot.geneExpressionLevel',
    defaultMessage: "Subject's {gene} Expression",
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    height: plotHeight,
  },
  plot: {
    width: '100%',
    height: '100%',
  },
}));

export const BoxPlot = ({
  data,
  expression,
  gene,
  isLoading,
  xtitle,
  ytitle,
}) => {
  const classes = useStyles({});

  const { width } = useWindowSize();
  const { formatMessage } = useIntl();

  return (
    <PlotContainer className={classes.root} isLoading={isLoading}>
      <Plot
        className={classes.plot}
        data={
          data?.length > 0
            ? [
                ...data,
                buildHorizontalExpressionTrace({
                  expressionValue: expression,
                  boxPlotTraces: data,
                  traceName: formatMessage(messages.geneExpressionLevel, {
                    gene,
                  }),
                }),
              ]
            : []
        }
        layout={{
          hovermode: 'x unified',
          height: plotHeight,
          width: width - 100,
          yaxis: {
            title: {
              text: `<b>${ytitle}</b>`,
              family:
                '"Lato", Helvetica, Roboto, Arial, "Lucida Grande", sans-serif',
            },
          },
          xaxis: {
            automargin: true,
            title: {
              text: `<b>${xtitle}</b>`,
              family:
                '"Lato", Helvetica, Roboto, Arial, "Lucida Grande", sans-serif',
            },
          },
        }}
      />
    </PlotContainer>
  );
};
